<template>
    <div>
        <card-header title="Edit Category" icon="fa-pencil"/>

        <card-body>
            <category-form :category="category" :is-subcategory="!!category.parent_id"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button
                        type="is-danger"
                        size="is-small"
                        outlined
                        @click="confirmDelete"
                        :loading="deleting"
                    >
                        <i class="fas fa-trash mr-2"></i>Delete
                    </b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!category.title"
                        :loading="saving"
                    >
                        <i class="fas fa-save mr-2"></i>Save Changes
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardFooter from "@/TIER/components/CardFooter";
import CategoryForm from "./CategoryForm";

import {client as http} from "@/http_client";

export default {
    components: {
        CardHeader,
        CardBody,
        CardFooter,
        CategoryForm
    },
    props: ['card', 'categoryId'],
    data() {
        return {
            category: {
                title: '',
                description: '',
                sort: 0
            },
            saving: false,
            deleting: false
        };
    },
    methods: {
        loadCategory: function() {
            this.$emit('loading', true);
            http.get(`course-categories/${this.categoryId}`).then(response => {
                this.category = response.data;
                this.$emit('loading', false);
            }).catch(err => {
                console.log(err);
                this.$emit('loading', false);
            });
        },
        submit: function() {
            this.saving = true;

            const data = {
                title: this.category.title,
                description: this.category.description || null,
                sort: this.category.sort || 0
            };

            http.put(`course-categories/${this.categoryId}`, data).then(response => {
                this.$reloadCard('course-categories');
                this.$closeCard(this.card);
            }).catch(err => {
                console.log(err);
                this.saving = false;
                this.$buefy.toast.open({
                    message: 'Failed to save category',
                    type: 'is-danger'
                });
            });
        },
        confirmDelete: function() {
            this.$buefy.dialog.confirm({
                title: 'Delete Category',
                message: 'Are you sure you want to delete this category? This will also delete any subcategories.',
                confirmText: 'Delete',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteCategory()
            });
        },
        deleteCategory: function() {
            this.deleting = true;
            http.delete(`course-categories/${this.categoryId}`).then(response => {
                this.$reloadCard('course-categories');
                this.$closeCard(this.card);
            }).catch(err => {
                console.log(err);
                this.deleting = false;
                this.$buefy.toast.open({
                    message: 'Failed to delete category',
                    type: 'is-danger'
                });
            });
        },
        reload: function() {
            this.loadCategory();
        }
    },
    mounted: function() {
        this.loadCategory();
    }
};
</script>
